import useFont from '@/utils/hooks/useFont'
import FaviconService from './FaviconService'
import MaliciousExtensionDetectorService from './MaliciousExtensionDetectorService'
import NotificationService from './NotificationService'

export interface GlobalServicesProps {
	isNotificationServiceEnabled: boolean
}

export default function GlobalServices({ isNotificationServiceEnabled }: GlobalServicesProps) {
	useFont()

	return (
		<>
			<FaviconService />
			{isNotificationServiceEnabled && <NotificationService />}
			<MaliciousExtensionDetectorService />
		</>
	)
}
